<ng-container *ngIf="allFilters$ | async as allFilters">
  <div class="filtering" *ngIf="allFilters.length">
    <cyborg-facet-buttons
      [facets]="allFilters$ | async"
      [groupByCategory]="false"
    ></cyborg-facet-buttons>
  </div>
</ng-container>

<div class="clear-all">
  <p (click)="onClearAllFilters()">Clear All Filters</p>
</div>
